(() => {
  const ready = (scope = document) => {
    scope.querySelectorAll('[data-kg-color-picker]:not([data-kg-picker-ready])').forEach((picker) => {
      picker.dataset.kgPickerReady = 'true';
      const image = picker.querySelector('[data-kg-lamp]');
      const source = picker.querySelector('[data-kg-lamp-source]');
      const canvas = picker.querySelector('[data-kg-lamp-canvas]');
      const buttons = Array.from(picker.querySelectorAll('[data-kg-color]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = Math.max(0, buttons.findIndex((button) => button.getAttribute('aria-pressed') === 'true'));
      let cycleTimer;

      const showColor = (button) => {
        if (!image || !button) return;
        image.style.setProperty('--kg-lamp-hue', `${button.dataset.hue}deg`);
        image.style.setProperty('--kg-lamp-saturation', button.dataset.saturation || '1');
        image.style.setProperty('--kg-lamp-brightness', button.dataset.brightness || '1');
        buttons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        activeIndex = buttons.indexOf(button);
      };

      const startCycle = () => {
        window.clearInterval(cycleTimer);
        if (reduceMotion || buttons.length < 2) return;
        cycleTimer = window.setInterval(() => {
          activeIndex = (activeIndex + 1) % buttons.length;
          showColor(buttons[activeIndex]);
        }, 2200);
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          showColor(button);
          startCycle();
        });
      });

      showColor(buttons[activeIndex]);
      startCycle();

      const startTentacleMotion = () => {
        if (
          reduceMotion ||
          picker.dataset.kgTentacleMotion === 'false' ||
          !image ||
          !source ||
          !canvas
        ) return;

        const context = canvas.getContext('2d');
        if (!context) return;

        const initialize = () => {
          const width = source.naturalWidth;
          const height = source.naturalHeight;
          if (!width || !height) return;

          canvas.width = width;
          canvas.height = height;

          const zoneStart = Math.round(height * 0.34);
          const zoneEnd = Math.round(height * 0.78);
          const supportLeft = Math.round(width * 0.491);
          const supportWidth = Math.max(10, Math.round(width * 0.018));
          const stripHeight = Math.max(12, Math.round(height / 72));
          const speed = Math.max(3, Number(picker.dataset.kgTentacleSpeed) || 5) * 1000;
          const intensity = Math.max(1, Number(picker.dataset.kgTentacleIntensity) || 4);
          const amplitude = width * intensity * 0.003;
          let lastFrame = 0;

          const render = (time) => {
            window.requestAnimationFrame(render);
            if (document.hidden || time - lastFrame < 40) return;
            lastFrame = time;

            context.clearRect(0, 0, width, height);
            context.drawImage(source, 0, 0, width, height);

            for (let y = zoneStart; y < zoneEnd; y += stripHeight) {
              const currentStrip = Math.min(stripHeight + 1, zoneEnd - y);
              const progress = (y - zoneStart) / (zoneEnd - zoneStart);
              const envelope = Math.sin(Math.PI * progress);
              const phase = (time / speed) * Math.PI * 2 + progress * 3.2;
              const offset = Math.sin(phase) * envelope * amplitude;

              context.drawImage(
                source,
                0,
                y,
                width,
                currentStrip,
                offset,
                y,
                width,
                currentStrip
              );
            }

            // Restore the slim acrylic support from the original frame so only
            // the flexible tentacles sway. The support and base remain fixed.
            context.drawImage(
              source,
              supportLeft,
              zoneStart,
              supportWidth,
              zoneEnd - zoneStart,
              supportLeft,
              zoneStart,
              supportWidth,
              zoneEnd - zoneStart
            );

            image.classList.add('is-animated');
          };

          window.requestAnimationFrame(render);
        };

        if (source.complete) initialize();
        else source.addEventListener('load', initialize, { once: true });
      };

      startTentacleMotion();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => ready());
  else ready();
  document.addEventListener('shopify:section:load', (event) => ready(event.target));
})();
